/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2019, Zumper
 * @description router constants
 */

import { VerifyCreditIdentityPage } from './verifyCreditIdentity'

export const BASEPATH = '/manage' as const

export const ZUMPER_LISTING_BASEPATH = '/apartments-for-rent' as const
export const ZUMPER_BUILDING_BASEPATH = '/apartment-buildings' as const
export const BUILDING = 'building' as const
export const CREATE_LEASE = 'create-lease' as const
export const POST_LISTING = 'post-listing' as const
export const SCREEN_TENANTS = 'screen-tenants' as const
export const CREATE_PROPERTY = 'create-property' as const
export const EDIT_PROPERTY = 'edit-property' as const
export const FAQ = 'faq' as const
export const FLOORPLAN = 'floorplan' as const
export const HELP = 'help' as const
export const LISTING = 'listing' as const
export const MARK_PAID = 'mark-paid' as const
export const OVERVIEW = 'overview' as const
export const PASSWORD_RESET = 'password-reset' as const
export const PAYOUTS = 'payouts' as const
export const PROPERTIES = 'properties' as const
export const RENTERS = 'renters' as const
export const SCREEN_RENTER = 'screen-renter' as const
export const SETTINGS = 'settings' as const
export const SIGN_IN = 'sign-in' as const
export const SIGN_UP = 'sign-up' as const
export const SUPPORT = 'support' as const
export const UPGRADE = 'upgrade' as const
export const VERIFY_IDENTITY = 'verify-identity' as const
export const MESSAGING = 'messaging' as const
export const MESSAGES = 'messages' as const

// landing pages
export const LANDING_HOMEPAGE = BASEPATH
export const LANDING_SCREEN_TENANTS = `${BASEPATH}/${SCREEN_TENANTS}` as const
export const LANDING_POST_LISTING = `${BASEPATH}/${POST_LISTING}` as const

export const SIGN_IN_PATH = `${BASEPATH}/${SIGN_IN}` as const
export const SIGN_UP_PATH = `${BASEPATH}/${SIGN_UP}` as const

export const MANAGE_POST_LISTING_SIGN_UP =
  `${SIGN_UP_PATH}?intent=${POST_LISTING}` as const
export const MANAGE_SCREEN_TENANTS_SIGN_UP =
  `${SIGN_UP_PATH}?intent=${SCREEN_TENANTS}` as const

export const MANAGE_PROPERTY_BASEPATH = `${BASEPATH}/${PROPERTIES}` as const
export const FAQ_BASEPATH = `${BASEPATH}/${FAQ}` as const
export const MESSAGING_BASEPATH = `${BASEPATH}/${MESSAGING}` as const
export const MESSAGES_BASEPATH = `${BASEPATH}/${MESSAGES}` as const
export const BUILDING_BASEPATH =
  `${MANAGE_PROPERTY_BASEPATH}/${BUILDING}` as const
export const LISTING_BASEPATH =
  `${MANAGE_PROPERTY_BASEPATH}/${LISTING}` as const
export const CREATE_PROPERTY_BASEPATH =
  `${BASEPATH}/${CREATE_PROPERTY}` as const
export const EDIT_PROPERTY_BASEPATH = `${BASEPATH}/${EDIT_PROPERTY}` as const
export const SCREEN_RENTER_BASEPATH = `${BASEPATH}/${SCREEN_RENTER}` as const
export const RENTER_BASEPATH = `${BASEPATH}/${RENTERS}` as const
export const SETTINGS_BASEPATH = `${BASEPATH}/${SETTINGS}` as const
export const UPGRADE_BASEPATH = `${BASEPATH}/${UPGRADE}` as const
export const ADD_ONS_BASEPATH = `${BASEPATH}/add-ons` as const
export const CROSS_SELL_BASEPATH = `${BASEPATH}/cs` as const

export const SCREEN_RENTER_COLLECTION_METHOD_PATH =
  `${SCREEN_RENTER_BASEPATH}/collection-method` as const
export const SCREEN_RENTER_LOCATION_PATH =
  `${SCREEN_RENTER_BASEPATH}/location` as const

export const VERIFY_IDENTITY_BASEPATH =
  `${BASEPATH}/${VERIFY_IDENTITY}` as const
export const VERIFY_IDENTITY_ERROR =
  `${VERIFY_IDENTITY_BASEPATH}/${VerifyCreditIdentityPage.ERROR}` as const
export const VERIFY_IDENTITY_INFO =
  `${VERIFY_IDENTITY_BASEPATH}/${VerifyCreditIdentityPage.INFO}` as const
export const VERIFY_IDENTITY_SUCCESS =
  `${VERIFY_IDENTITY_BASEPATH}/${VerifyCreditIdentityPage.SUCCESS}` as const
export const VERIFY_IDENTITY_TERMS =
  `${VERIFY_IDENTITY_BASEPATH}/${VerifyCreditIdentityPage.TERMS}` as const

export const LEASES_BASEPATH = `${BASEPATH}/leases` as const
export const CREATE_LEASE_BASEPATH = `${BASEPATH}/${CREATE_LEASE}` as const
export const CREATE_LEASE_START = `${CREATE_LEASE_BASEPATH}/intro` as const

export const OLD_PRO_BASEPATH = '/legacy-pro' as const
export const OLD_PRO_HOME = `${OLD_PRO_BASEPATH}/home` as const
export const HELP_PATH = `${BASEPATH}/${HELP}` as const

export const REACTIVATED_ACCOUNT_PATH =
  '/zumper-account/unactivated-account' as const
export const SESSIONS_PATH = '/zumper-account/signout' as const
export const RESET_PASSWORD = '/zumper-account/password_reset' as const
export const ZENDESK_SUPPORT =
  'https://help.zumper.com/hc/en-us/requests/new' as const
export const ZUMPER_SUPPORT = 'mailto:support@zumper.com' as const
export const ZUMPER_TOS = 'https://www.zumper.com/terms-and-conditions' as const

export const MANAGE_LANDLORD_RESOURCES = `${BASEPATH}/resources` as const
export const EXAMPLE_SCREENING_REPORT =
  'https://d214hhm15p4t1d.cloudfront.net/screening/example_report.pdf' as const
export const RENTER_GUARANTEE_LANDING_PAGE =
  'https://signup.zumper.com/renter-guarantee' as const
export const RENT_GUARANTEE_TOS_PAGE =
  'https://signup.zumper.com/renter-guarantee-terms-and-conditions' as const
export const INSTARENT_LANDLORDS_PAGE =
  'https://signup.zumper.com/instarent-property' as const
export const RICH_MEDIA_GUIDE_BLOG_POST =
  'https://www.zumper.com/manage/resources/marketing-your-rental-property-with-video-tours/' as const
export const INSTARENT_TERMS_AND_CONDITIONS =
  'https://signup.zumper.com/instarent-terms-and-conditions' as const

export const DIRECT_LISTINGS_BASEPATH = `${BASEPATH}/premium-listings` as const
export const DL_CHECKOUT_URL = `${DIRECT_LISTINGS_BASEPATH}/checkout` as const
export const DL_SIGNUP_URL = `${DIRECT_LISTINGS_BASEPATH}/sign-up` as const
export const DL_LISTING_SOURCE_URL =
  `${DIRECT_LISTINGS_BASEPATH}/source` as const
export const DL_SUPPORT = 'mailto:directlistings@zumper.com' as const
export const DIRECT_LISTINGS_BILLING_EMAIL =
  'mailto:directlistingsbilling@zumper.com'

export const VALIDATE_EMAIL_URL = `${BASEPATH}/validate-email` as const
export const DENY_VALIDATE_PRO_EMAIL_URL =
  `${BASEPATH}/deny-validate-pro-email` as const
